
import { defineComponent, ref, onMounted } from "vue"
import { useStore } from "vuex"
import { useRoute, useRouter } from "vue-router"
import { Actions } from "@/store/enums/StoreEnums"
import { setCurrentPageBreadcrumbs } from "@/core/helpers/breadcrumb"
import { ElMessage } from "element-plus"
import { Loading } from '@element-plus/icons-vue'
import { MatchGameRecord, GameStep } from "@/store/modules/MatchGameRecordModule"

export default defineComponent({
  components: {
    Loading
  },
  setup() {
    const store = useStore()
    const route = useRoute()
    const router = useRouter()

    const recordId = Number(route.params.id)
    const loading = ref(true)
    const record = ref<MatchGameRecord | null>(null)

    onMounted(async () => {
      setCurrentPageBreadcrumbs("记录详情", ["对对碰系统", "游戏记录;match_game_records"])

      try {
        await store.dispatch(Actions.GET_MATCH_GAME_RECORD, recordId)
        record.value = store.getters.currentMatchGameRecord
      } catch (error) {
        ElMessage.error('加载记录失败')
      } finally {
        loading.value = false
      }
    })

    const getMatchCountTagType = (matchCount: number) => {
      if (matchCount === 0) return 'info'
      if (matchCount >= 9) return 'danger'
      if (matchCount >= 5) return 'warning'
      return 'success'
    }

    const getItemTypeTagType = (itemType: string) => {
      if (itemType === 'SP') return 'danger'
      if (['A', 'B', 'C'].includes(itemType)) return 'warning'
      return 'info'
    }

    const getStepType = (step: GameStep) => {
      if (step.type === 'init') return 'primary'
      if (step.type === 'end') return 'success'
      if (step.matched) return 'success'
      return 'info'
    }

    const getStepTitle = (step: GameStep, index: number) => {
      if (step.type === 'init') return '游戏开始'
      if (step.type === 'end') return '游戏结束'
      return `第 ${step.step || index} 步`
    }

    const goBack = () => {
      router.push({ name: 'match_game_records' })
    }

    return {
      loading,
      record,
      getMatchCountTagType,
      getItemTypeTagType,
      getStepType,
      getStepTitle,
      goBack
    }
  }
})
